import { render, staticRenderFns } from "./editpassword.vue?vue&type=template&id=60934753&scoped=true&"
import script from "./editpassword.vue?vue&type=script&lang=js&"
export * from "./editpassword.vue?vue&type=script&lang=js&"
import style0 from "./editpassword.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editpassword.vue?vue&type=style&index=1&id=60934753&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60934753",
  null
  
)

export default component.exports